import { combineReducers, createReducer, on } from '@ngrx/store';
import { Offer } from '../../models/offers.model';
import {
  loadHubOffers,
  loadHubOffersSuccess,
  loadHubOffersFailure,
  dismissHubOffer,
  resetHubOffers,
  loadOfferOffers,
  loadOfferOffersSuccess,
  loadOfferOffersFailure,
  dismissOfferOffers,
  resetOfferOffers,
} from '../actions/offers.actions';

export const offersFeatureKey = 'offers';

export interface OffersContext {
  offers: Offer[];
  dismissOffer: boolean;
  error: any;
  processing: boolean;
  processed: boolean;
}

export interface OffersState {
  hubOffers: OffersContext;
  offerOffers: OffersContext;
}

export const initialOffersState: OffersContext = {
  offers: null,
  dismissOffer: false,
  error: null,
  processing: false,
  processed: false,
};

export const hubReducer = createReducer(
  initialOffersState,
  on(loadHubOffers, (state, action) => ({
    ...state,
    error: null,
    processing: true,
    processed: false,
  })),

  on(loadHubOffersSuccess, (state, action) => ({
    ...state,
    offers: action.data,
    error: null,
    processing: false,
    processed: true,
  })),

  on(loadHubOffersFailure, (state, action) => ({
    ...state,
    error: action.error,
    processing: false,
    processed: true,
  })),

  on(dismissHubOffer, (state) => ({
    ...state,
    dismissOffer: true,
  })),

  on(resetHubOffers, (state) => ({
    ...state,
    offers: null,
  }))
);

export const offerReducer = createReducer(
  initialOffersState,
  on(loadOfferOffers, (state, action) => ({
    ...state,
    error: null,
    processing: true,
    processed: false,
  })),

  on(loadOfferOffersSuccess, (state, action) => ({
    ...state,
    offers: action.data,
    error: null,
    processing: false,
    processed: true,
  })),

  on(loadOfferOffersFailure, (state, action) => ({
    ...state,
    error: action.error,
    processing: false,
    processed: true,
  })),

  on(dismissOfferOffers, (state) => ({
    ...state,
    dismissOffer: true,
  })),

  on(resetOfferOffers, (state) => ({
    ...state,
    offers: null,
  }))
);

export const offersReducer = combineReducers<OffersState>({
  hubOffers: hubReducer,
  offerOffers: offerReducer,
});
